<template>
  <div class="about mt-2 py-5">
    <h1>Email verified page (temp)</h1>
    <div v-if="linkValidated">
      Email validated successfully
    </div>
    <div v-else>
      Error validating email<br />
      {{ linkValidationErrorMessage }}
    </div>
  </div>
</template>

<script>
import { HTTP } from '@/shared/http';
export default {
  name: "EmalVerfied",
  data() {
    return {
      email: '',
      emailIsMissing: false,
      password: '',
      passwordIsMissing: false,
      invalidPassword: 'warnings.invalidPassword',
      invalidEmail: 'warnings.invalidEmail',
      linkValidated: false,
      linkValidationError: false,
      linkValidationErrorMessage: '',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },

  created() {
    console.log(this.$route);
    if (this.$route.params.id && this.$route.params.hash) {
      //const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = `/email/verify/${this.$route.params.id}/${this.$route.params.hash}`;
      HTTP.get(url)
        .then((response) => {
          console.log('link validation response', response);
          this.linkValidated = true;
          this.$router.push("/signin");
        })
        .catch((error) => {
          this.linkValidationErrorMessage = error;
          console.log('link validation error', error);
        });
    }
  },
};
</script>
